module.exports = __webpack_public_path__ + "img/Sigma_Technology.658e92f6.png";